import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

const optionRequiredInputMissingError = (property: string) => new Error(`MuiOption: Required property ${property} has not been set!`);

@Component({
  selector: 'mui-option',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `,
  styles: [':host { display: none }']
})
export class MuiOption<T> implements OnInit {
  /* Todo: Make this required once we migrate to Angular 16. */
  /** The value that is used in the model */
  @Input() value!: T;

  /* Todo: Make this required once we migrate to Angular 16. */
  /** A string representation of the option which is used in the control */
  @Input() label!: string;

  /** Flag that indicated if the option is disabled */
  @Input() disabled = false;

  /** Can be used to provide any additional payload to the option object */
  @Input() context?: any;

  /** A reference to the <mui-option> tag's content */
  @ViewChild(TemplateRef) template?: TemplateRef<any>;

  ngOnInit(): void {
    if (this.label === undefined) {
      throw optionRequiredInputMissingError('label');
    }
    if (this.value === undefined) {
      throw optionRequiredInputMissingError('value');
    }
  }
}
